import { render, staticRenderFns } from "./PanelCompetitionUpdateResults.vue?vue&type=template&id=02bbfedc&"
import script from "./PanelCompetitionUpdateResults.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionUpdateResults.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionUpdateResults.vue?vue&type=style&index=0&id=02bbfedc&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bbfedc')) {
      api.createRecord('02bbfedc', component.options)
    } else {
      api.reload('02bbfedc', component.options)
    }
    module.hot.accept("./PanelCompetitionUpdateResults.vue?vue&type=template&id=02bbfedc&", function () {
      api.rerender('02bbfedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionUpdateResults.vue"
export default component.exports